<template>
  <span></span> 
</template>
<script>
  export default {
    data:() => ({
      active: 'home',
       
    })
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
